import { XF } from "./js/XF";

const elRR = document.getElementById("thread-recommended-reading");
let elThreads = elRR?.querySelector(".california-thread-list");

if (!elRR || !elThreads)
  throw new Error("Could not find recommended reading elements");

async function fetchThreads() {
  try {
    if (!elThreads || !elRR) return;

    const data = await $.get(
      elRR.dataset.frontier === "1"
        ? "/frontier/similar-threads/"
        : "/similar-threads",
      {
        threadTitle: elRR.dataset.threadTitle,
        threadId: elRR.dataset.threadId ? elRR.dataset.threadId : undefined,
        timeCreated: elRR.dataset.timeCreated
          ? parseInt(elRR.dataset.timeCreated || "", 10)
          : undefined,
      }
    );
    elThreads.outerHTML = data.html.content;
    elThreads = elRR.querySelector(".california-thread-list");
    if (!elThreads) {
      elRR.remove();
      return;
    }
    XF.activate(elRR);
    const event = new CustomEvent("newAdLoad", {
      detail: {},
    });
    document.dispatchEvent(event);
  } catch (err) {
    console.error(err);
    elRR?.remove();
  }
}

if (elRR.dataset.intersect !== "1") {
  fetchThreads();
} else {
  const observer = new IntersectionObserver(async (entries) => {
    if (entries.some((i) => i.isIntersecting)) {
      observer.disconnect();
      fetchThreads();
    }
  });
  observer.observe(elRR);
}
